import DailySignItem from "./dailysign_item";
import LanguageManager from "../../../../manager/language_manager";

const { ccclass, property } = cc._decorator;
@ccclass
export default class DailySignDailyItem extends DailySignItem {
    @property(cc.Label)
    labelTimesTag: cc.Label = null

    @property(cc.Node)
    nodeSelect: cc.Node = null

    @property(cc.Node)
    nodeSelectEffect: cc.Node = null

    show(show: boolean, data?: any): boolean{
        if(super.show(show, data)){
            if(show){
                this.labelTimesTag.string = LanguageManager.t('daily_sign_times').format(data.dayIndex)
                this.nodeSelect.active = !data.isFinish && data.isReceive   
                this.nodeSelectEffect.active = !data.isFinish && data.isReceive   
            }
            return true
        }
        return false
    }

}